import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import useURL from "./useURL";

// TODO: SVEN: Find better smaller logos (signle letter?)

const useDocumentTitle = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const { title, faviconPath, path } = useURL();

    document.title = title;
    setFavicon(faviconPath);
  }, [location]);
};

// Helper function to set favicon
const setFavicon = (faviconPath) => {
  // Remove existing favicon links
  const existingLinks = document.querySelectorAll('link[rel*="icon"]');
  existingLinks.forEach((link) => link.remove());

  // Create new favicon link
  const link = document.createElement("link");
  link.rel = "shortcut icon";
  link.href = faviconPath;
  document.head.appendChild(link);
};

export default useDocumentTitle;
